/**
 * Enum for read only level.
 * A higher priority level cannot be overridden a lower priority level.
 */
export enum ReadOnlyPriority {
  None,
  // Relational
  Relational = 1,
  // Specific to Historical
  Historical = 2,
  // Form Designer
  Design = 3,
  // Only affects the field if it's a result field, which is always read-only
  Formula = 4,
  // Field cannot be edited due to permissions (form/instance/folder permissions)
  Permissions = 5,
  // Field is a protected field (System fields, TRN/Exam fields, etc.)
  Protected = 7,
  // Future Functionality
  Scripting = 8,
  //Used for distribution/assessment orgcharts
  HardCoded = 9,
  // Form is in read/view mode (nothing can be edited)
  ReadMode = 10,

}
